import React from 'react';
import {
  ListItem as MuiListItem,
  Paper,
  Skeleton,
  Stack,
  styled,
  Typography,
  Typography as MuiTypography,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

const ListItem = styled(MuiListItem)(() => ({
  width: '100%',
  display: 'flex',
  paddingLeft: 0,
  alignItems: 'center',
  justifyContent: 'space-between',
}));

// the contact persons of the operator, in the order they are shown
const CONTACT_PERSON_SECTIONS = [
  {
    label: 'LBLOperatorGenericInfoSection',
    detailsKey: 'contactPersonDetails',
  },
  {
    label: 'LBLOperatorBillingRelatedInfoSection',
    detailsKey: 'bookkeepingContactPersonDetails',
  },
  {
    label: 'LBLOperatorTechnicalInfoSection',
    detailsKey: 'technicianContactDetails',
  },
];

const CONTACT_PERSON_FIELDS = [
  { label: 'LBLContactPersonName', key: 'contactPersonName' },
  { label: 'LBLContactPersonPosition', key: 'contactPersonPosition' },
  { label: 'LBLContactPersonEmail', key: 'contactPersonEmail' },
  { label: 'LBLContactPersonPhone', key: 'contactPersonPhone' },
];

/**
 * Contact information of the operator (general, billing related and technical contact person),
 * shown in the operator details between the bill template and the ERP import data.
 */
function OperatorContactInformationView({ operatorInfo, loadingOperator }) {
  const { t } = useTranslation();

  return (
    <Stack direction="row">
      <Paper sx={{ px: 2, py: 4, mb: 12, width: '100%' }}>
        <Stack direction="row" sx={{ width: '100%' }}>
          <Box flexGrow={1}>
            <MuiTypography variant="h3" component="h2" gutterBottom>
              {t('LBLOperatorContactInformation')}
            </MuiTypography>

            {CONTACT_PERSON_SECTIONS.map((section) => (
              <ListItem key={section.detailsKey}>
                <Typography>{t(section.label)}</Typography>

                <Typography align="right">
                  {loadingOperator ? (
                    <>
                      <Skeleton width={130} />
                      <Skeleton width={130} />
                    </>
                  ) : (
                    <Typography sx={{ textAlign: 'right' }}>
                      {CONTACT_PERSON_FIELDS.map((field) => ({
                        label: field.label,
                        value: operatorInfo?.[section.detailsKey]?.[field.key],
                      }))
                        .filter(
                          (item) =>
                            item.value && String(item.value).trim().length > 0
                        )
                        .map((item) => (
                          <div key={item.label}>
                            <strong>{t(item.label)}:</strong> {item.value}
                          </div>
                        ))}
                    </Typography>
                  )}
                </Typography>
              </ListItem>
            ))}
          </Box>
        </Stack>
      </Paper>
    </Stack>
  );
}

export default OperatorContactInformationView;
